function camelToKebab(string: string): string {
  return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export default camelToKebab;



// WEBPACK FOOTER //
// ./default-modules/ui/core/theme/utils/camelToKebab.ts